import { UIStore } from './uiStore';
import { UserStoreKC } from './userStoreKC';
import { ApiStore } from './apiStore';
import { EditAccountStore } from './editAccountStore';
import { BreadcrumbsStore } from './breadcrumbsStore';
import { ErrorStore } from './errorStore';
import Keycloak from 'keycloak-js';

export class RootStore {
  stores: {
    apiStore: ApiStore;
    uiStore: UIStore;
    errorStore: ErrorStore;
    userStore: UserStoreKC;

    breadcrumbsStore: BreadcrumbsStore;
    editAccountStore: EditAccountStore;
  };

  constructor(keycloak: Keycloak) {
    this.stores = {
      uiStore: new UIStore(this),
      errorStore: new ErrorStore(this),
      userStore: new UserStoreKC(this, keycloak),
      apiStore: new ApiStore(this),

      breadcrumbsStore: new BreadcrumbsStore(this),
      editAccountStore: new EditAccountStore(this),
    };
  }
}
